import React from 'react'
import { Container, IconContainer, Div } from './ModelSelectionButton.styles'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import Icon from '../Icon/Icon'
import { COLORS } from '../../constants'
import { Product } from '../../services/types/product'

type ModelSelectionButtonProps = {
  product: Product
  selectedProducts: Product[]
  setSelectedProducts: (products: Product[]) => void
}

const ModelSelectionButton: React.FC<ModelSelectionButtonProps> = ({
  product,
  selectedProducts,
  setSelectedProducts
}) => {
  const { partName, productNumber, leadTime } = product
  const isPartNumberAlreadySelected = selectedProducts.some(
    (selectedProduct) => selectedProduct.productNumber === productNumber
  )

  const handleProductClick = () => {
    if (isPartNumberAlreadySelected) {
      return
    } else {
      setSelectedProducts([...selectedProducts, product])
    }
  }

  return (
    <Container
      onClick={handleProductClick}
      $selected={false} //{isPartNumberAlreadySelected} <-- TO-ACTIVATE
    >
      <Div>
        {productNumber && (
          <p>
            Model #: <span>{productNumber}</span>
          </p>
        )}
        {partName && (
          <p>
            <span>{partName}</span>
          </p>
        )}
        {leadTime && (
          <p>
            <span>{leadTime}</span>
          </p>
        )}
      </Div>

      <IconContainer>
        {/*TO-ACTIVATE*/}
        {/*{!isPartNumberAlreadySelected && (*/}
        {/*  <Icon icon={faChevronRight} size="30px" color={COLORS.darkGray} />*/}
        {/*)}*/}
        <Icon icon={faChevronRight} size="30px" color={COLORS.darkGray} />
      </IconContainer>
    </Container>
  )
}

export default ModelSelectionButton
